var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 pa-0"},[_c('GlobalTextEditor',_vm._b({staticClass:"text-editor-container",attrs:{"value":_vm.field.content},on:{"update:value":function($event){return _vm.$set(_vm.field, "content", $event)}}},'GlobalTextEditor',{
            elClass: 'text-editor',
            editable: true,
            required: true,
            loading: false
        },false)),_c('v-input',{attrs:{"rules":_vm.fieldTextR,"type":"hidden"},model:{value:(_vm.shadowTextInput),callback:function ($$v) {_vm.shadowTextInput=$$v},expression:"shadowTextInput"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }